var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"main"},[_c('div',[_c('v-header')],1),_c('div',{staticClass:"left"},[_c('v-menu')],1),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"el-zoom-in-top"}},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }